import { useEffect } from "react";
import { Icon } from "@/components/icon";
import { useRouter } from "next/router";
import { usePath } from "@/contexts/path/path";
import css from "./.module.scss";
import Image from "next/image";
import { QUERY_PARAM_VALUES } from "@/common/constants";
import { Modal } from "@aqar-app/react-ui";
import { ClassicModal } from "@/components/Listing/ListingScreen/classicModal";
import { useMutation } from "@apollo/client";
import { useAuthState } from "@/contexts/auth/auth.provider";
import { DISABLE_RENT_NOW_PAY_LATER } from "@/graphql/queries/listing";
import { SuccessAlert, WarningAlert } from "@/components/login-alert";

function RnplControls({ rnpl_monthly_price, id, price }) {
  const router = useRouter();
  const { category, listingType, listing, updateContext } = usePath();
  const { token } = useAuthState();

  const [disableRNPL] = useMutation(DISABLE_RENT_NOW_PAY_LATER, {
    context: { token },
  });

  const removeActionParam = () => {
    const { action, ...restQuery } = router.query;
    router.replace(
      {
        pathname: router.pathname,
        query: restQuery,
      },
      undefined,
      { shallow: true },
    );
  };

  const openConfirmationModal = () => {
    setTimeout(
      () =>
        Modal.open(
          <ClassicModal
            newDesign
            close={false}
            title="إيقاف الخدمة"
            ok={{
              label: "تراجع",
              cb: (e) => {
                removeActionParam();
                Modal.close(e);
              },
            }}
            cancel={{
              label: "نعم",
              cb: (e) => {
                Modal.close(e);
                removeActionParam();
                disableRNPL({ variables: { id } })
                  .then(() => {
                    Modal.open(
                      <SuccessAlert
                        text="تم إيقاف الخدمة بنجاح"
                        onOk={() => {
                          updateContext({
                            listing: {
                              ...listing,
                              rnpl_monthly_price: undefined,
                              __router__: { replace: true },
                            },
                          });
                        }}
                      />,
                    )();
                  })
                  .catch(() => {
                    Modal.open(
                      <WarningAlert text="حدث خطأ أثناء إيقاف الخدمة" />,
                    )();
                  });
              },
            }}
            body={<p>هل أنت متأكد من رغبتك في إيقاف الخدمة؟</p>}
          />,
        )(),
      0,
    );
  };

  useEffect(() => {
    if (router.query.action === QUERY_PARAM_VALUES.disableRnplConfirm) {
      openConfirmationModal();
    }
  }, [router.query.action]);

  return (
    <button
      onClick={() => {
        const rnplUrl = `/rnpl?id=${id}&value=${price}&listing_type=${listingType}&category=${category?.en}`;

        if (rnpl_monthly_price) {
          return router.push(
            `${rnplUrl}&action=${QUERY_PARAM_VALUES.disableRnpl}`,
          );
        }

        router.push(rnplUrl);
      }}
      className={css.card + " " + css.sov_owner_btn}
    >
      <Image src="/rnpl_30.png" alt="RNPL logo" width={30} height={30} />
      <div className={css.text}>
        <div>
          <h4>الدفعات الشهرية</h4>
          <span
            className={`${css.rnplStatus} ${
              rnpl_monthly_price ? css.active : ""
            }`}
          >
            {rnpl_monthly_price ? (
              <span className={css.ACTIVE} />
            ) : (
              <span className={css.INACTIVE} />
            )}
          </span>
        </div>
        <p>استلم الإيجار السنوي مقدمًا عند تفعيل الخدمة</p>
      </div>
      <Icon width={25} height={25} name="leftArrow-searches" />
    </button>
  );
}

export default RnplControls;
